import script from "./UConference.vue?vue&type=script&setup=true&lang=js"
export * from "./UConference.vue?vue&type=script&setup=true&lang=js"

import "./UConference.vue?vue&type=style&index=0&id=580ebbc7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-580ebbc7"]])

export default __exports__